import { useEffect, useState } from "react";
import InlineLoader from "./InlineLoader";
import { ImageShell, LoaderCenter, Img } from "./ImageWithLoaderStyles";

export default function ImageWithLoader({
  src,
  alt = "",
  loaderLabel = "Loading image…",
  showLoader = true,
  ...imgProps
}) {
  const [loaded, setLoaded] = useState(false);

  // reset when src changes
  useEffect(() => {
    setLoaded(false);
  }, [src]);

  return (
    <ImageShell>
      {showLoader && !loaded && (
        <LoaderCenter>
          <InlineLoader show label={loaderLabel} />
        </LoaderCenter>
      )}

      <Img
        src={src}
        alt={alt}
        onLoad={() => setLoaded(true)}
        onError={() => setLoaded(true)} // don’t hang forever
        $loaded={loaded}
        {...imgProps}
      />
    </ImageShell>
  );
}
